import * as Yup from "yup";
import event from "./event";

const {
  formField: { eventName, repeat, repetition }
} = event;

const validations = Yup.object().shape({
  [eventName.name]: Yup.string().required(eventName.errorMsg),
  [repeat.name]: Yup.string(),
  [repetition.name]: Yup.string().when(repeat.name, (repeatValue, schema) => {
    return schema.test({
      name: "repetition-test",
      test: function (repetitionValue) {
        const { path, createError } = this;

        if (!repetitionValue) return true;

        const parsedValue = parseInt(repetitionValue);

        switch (repeatValue) {
          case "minutely":
            if (parsedValue < 1 || parsedValue > 60) {
              return createError({
                path,
                message: "Must be between 1 and 60"
              });
            }

            break;
          case "hourly":
            if (parsedValue < 1 || parsedValue > 24)
              return createError({
                path,
                message: "Must be between 1 and 24"
              });
        }

        return true;
      }
    });
  })
});

export default validations;
